<template>
  <v-overlay
    v-model="mapDialogOpen"
    class="image-dialog-overlay"
  >
    <v-dialog
      v-model="mapDialogOpen"
      :scrim="false"
    >
      <v-card>
        <map-field
          v-if="mapCenterLatLng && marker"
          :center="mapCenterLatLng"
          :placemarks="[marker]"
          :zoom="14"
        />
      </v-card>
    </v-dialog>
  </v-overlay>
</template>

<script setup lang="ts">
import { useMaps } from '~/composables/useMaps';

const mapDialogStore = useMapDialogStore();
const { mapCenterCoordinates, mapCenterAddress, mapDialogOpen } = storeToRefs(mapDialogStore);

const mapCenterLatLng = ref<google.maps.LatLng | null>();
const marker = ref<google.maps.marker.AdvancedMarkerElement | null>();

const renderMap = async () => {
  const { googleMapsEmbedApiKey } = useRuntimeConfig().public;
  const { AdvancedMarkerElement, createFirePin } = await useMaps(googleMapsEmbedApiKey);

  let coordinates;
  if (mapCenterCoordinates.value) {
    coordinates = getLatLngFromString(mapCenterCoordinates.value);
  }
  else if (mapCenterAddress.value?.coordinates) {
    coordinates = getLatLngFromString(mapCenterAddress.value.coordinates);
  }

  if (coordinates) {
    mapCenterLatLng.value = new google.maps.LatLng(coordinates[0], coordinates[1]);

    marker.value = new AdvancedMarkerElement({
      position: mapCenterLatLng.value,
      content: createFirePin().element,
      title: 'Incident location',
      gmpClickable: true,
    });
  }
};

watch(mapDialogOpen, async open => {
  if (open) {
    renderMap();
  }
});

onMounted(async () => {
  if (mapDialogOpen.value) {
    await renderMap();
  }
});
</script>

<style scoped>
.img-placeholder-bg {
  background: rgba(0, 0, 0, 0.2)
}
</style>
